import { Injectable } from '@angular/core';
import { SalesforceAttachmentSource } from 'attachment-source-lib';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { IAttachmentSourceOptionLabelService, ISourceOption } from './iattachment-source-option-label.service';

@Injectable({ providedIn: 'root' })
export class SalesforceAttachmentSourceOptionLabelService implements IAttachmentSourceOptionLabelService {
  constructor(private salesforceAttachmentSource: SalesforceAttachmentSource) {}

  getOptions(optionPaths: string[]): Observable<ISourceOption[]> {
    const paths = optionPaths ?? [];
    if (!paths.length) {
      return of([]);
    }

    return forkJoin(
      paths.map((path) =>
        this.salesforceAttachmentSource.getPathLabel(path).pipe(
          map((label) => ({
            label: label ?? path,
            toolTip: path,
            path,
          })),
        ),
      ),
    );
  }
}
